// Compare matching of two inputs
export function CompareToValidatorDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      scope.$watch(attrs.compareToValidator, function () {
        ngModel.$validate();
      });

      ngModel.$validators.compareTo = function (modelValue) {
        var other = scope.$eval(attrs.compareToValidator);
        return !modelValue || !other || modelValue === other;
      };
    },
  };
}
